export const CDN_LOL_IMG_PATH = 'https://cdn.mobalytics.gg/assets/lol/images';
export const CDN_CGI_LOL_IMG_PATH = 'https://cdn.mobalytics.gg/cdn-cgi/image';
export const CDN_COMMON_IMG_PATH = 'https://cdn.mobalytics.gg/assets/common/images';
export const CDN_COMMON_ICON_PATH = 'https://cdn.mobalytics.gg/assets/common/icons';
export const CDN_LOL_VIDEO_PATH = 'https://cdn.mobalytics.gg/assets/lol/video';
export const CDN_VERSION = 'v0.0.1';

export const MOBA_APP_LINK = 'https://mobalytics.gg';
export const MOBA_HOME_URL = 'https://mobalytics.gg/lol';
export const MOBA_TIER_LIST_URL = 'https://mobalytics.gg/lol/tier-list';
export const MOBA_WIDGET_REPO_URL = 'https://mobalytics.gg/lol/glp/champion-widgets-and-tooltips';
